import { useEffect, useMemo } from "react";
import type { FavoriteProduct } from "@/api/hooks";
import { useFavoriteProductsStore } from "../store/favorite-products-store";
import { resolveFavoriteProductId } from "../utils/resolve-product-id";

export interface FavoriteRow {
  /** Satırın React key'i — id çözülemese de kararlı olsun diye offerId. */
  key: string;
  productId: string | null;
  product: FavoriteProduct;
}

/**
 * Liste yanıtını satırlara çevirir ve gelen ürünleri kalp store'una favori
 * olarak yazar — aynı ürün feed'de veya aramada görünürse kalbi dolu çizilsin.
 */
export const useFavoriteRows = (result?: FavoriteProduct[]): FavoriteRow[] => {
  const seedFavorites = useFavoriteProductsStore(
    (state) => state.seedFavorites,
  );

  const rows = useMemo<FavoriteRow[]>(
    () =>
      (result ?? []).map((product, index) => ({
        key: product.offerId || `favorite-${index}`,
        productId: resolveFavoriteProductId(product),
        product,
      })),
    [result],
  );

  const knownIds = useMemo(
    () =>
      rows.map((row) => row.productId).filter((id): id is string => !!id),
    [rows],
  );

  useEffect(() => {
    seedFavorites(knownIds);
  }, [knownIds, seedFavorites]);

  return rows;
};
